import React from 'react';
import cn from '../../../../lib/bem/index';
import img_logo from '../../../../assets/svg/img_logo.svg';

import './headerLogo_Component.scss';

const HeaderLogoComponent = () => {

    const classes = cn("headerLogoComponent");

    return (
        <div className={classes()}> 
            <img src={img_logo} alt={'pacifico_logo'} />
        </div>
    );
};

export default HeaderLogoComponent;